<template>
  <label class="al-label" test-id="al-label"><slot /></label>
</template>

<script>
export default {};
</script>

<style lang="scss">
$font-color: #36403f;
$font-size: 12.8px;

.al-label {
  color: $font-color;
  font-size: $font-size;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
